import { render } from "./AttributeDateTime.vue?vue&type=template&id=f0484c38&scoped=true"
import script from "./AttributeDateTime.vue?vue&type=script&lang=js"
export * from "./AttributeDateTime.vue?vue&type=script&lang=js"

import "./AttributeDateTime.vue?vue&type=style&index=0&id=f0484c38&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0484c38"]])

export default __exports__